import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get item
export const getItem = createAsyncThunk("item/getItem", async (param, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = param;

    const { data } = await API.getItem({ rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all item
export const getAllItem = createAsyncThunk("item/getAllItem", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllItem();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("item/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("item/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("item/getParticularPage", async (param, { rejectWithValue }) => {
  const { number, rowsPerPage, sortOrder } = param;

  try {
    const { data } = await API.getPageItem({ number, rowsPerPage, sortOrder });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
export const getItemById = createAsyncThunk("item/getItemById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getItemById(id);
    return data?.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

export const createItem = createAsyncThunk("item/createItem", async (data, { rejectWithValue, dispatch }) => {
  try {
    const {
      name,
      aliasName,
      serialNo,
      group,
      baseUnit,
      code,
      harmonicCode,
      category,
      productType,
      description,
      isActive,
      ignoreNegativeBalance,
      canEditRateSales,
      canEditRatePurchase,
      setAlternativeUnit,
      setStandardRate,
      setOpening,
      maintainBatch,
      useMfgDate,
      useExpDate,
      isTaxable,
      allowSalesPoint,
      productAdditionalDetailsProduct,
      productCosting,
      termConditionForInvoice,
      standardCostRate,
      standardSellingPrice,
      standardTradeRate,
      standardMrp,
    } = data;

    // const body = new FormData();
    const body = JSON.stringify({
      name,
      aliasName,
      serialNo,
      group,
      baseUnit,
      code,
      harmonicCode,
      category,
      productType,
      description,
      isActive,
      ignoreNegativeBalance,
      canEditRateSales,
      canEditRatePurchase,
      setAlternativeUnit,
      setStandardRate,
      setOpening,
      maintainBatch,
      useMfgDate,
      useExpDate,
      isTaxable,
      allowSalesPoint,
      productAdditionalDetailsProduct,
      productCosting,
      termConditionForInvoice,
      standardCostRate,
      standardSellingPrice,
      standardTradeRate,
      standardMrp,
    });

    // // Add common fields
    // const fields = {
    //   name,
    //   aliasName,
    //   serialNo,
    //   group,
    //   baseUnit,
    //   code,
    //   harmonicCode,
    //   category,
    //   productType,
    //   description,
    //   isActive,
    //   ignoreNegativeBalance,
    //   canEditRateSales,
    //   canEditRatePurchase,
    //   setAlternativeUnit,
    //   setStandardRate,
    //   setOpening,
    //   maintainBatch,
    //   useMfgDate,
    //   useExpDate,
    //   isTaxable,
    //   allowSalesPoint,
    // };
    // body.append("name", name);
    // body.append("aliasName", aliasName);
    // body.append("serialNo", serialNo);
    // body.append("group", group);
    // body.append("baseUnit", baseUnit);
    // body.append("code", code);
    // body.append("harmonicCode", harmonicCode);
    // body.append("category", category);
    // body.append("productType", productType);
    // body.append("description", description);
    // body.append("isActive", isActive);
    // body.append("ignoreNegativeBalance", ignoreNegativeBalance);
    // body.append("canEditRateSales", canEditRateSales);
    // body.append("canEditRatePurchase", canEditRatePurchase);
    // body.append("setStandardRate", setStandardRate);
    // body.append("setAlternativeUnit", setAlternativeUnit);
    // body.append("maintainBatch", maintainBatch);
    // body.append("useMfgDate", useMfgDate);
    // body.append("useExpDate", useExpDate);
    // body.append("isTaxable", isTaxable);
    // body.append("allowSalesPoint", allowSalesPoint);

    // const arrayFields = [
    //   { name: "productAdditionalDetailsProduct", data: productAdditionalDetailsProduct },
    //   { name: "productCosting", data: productCosting },
    //   { name: "standardCostRate", data: standardCostRate },
    //   { name: "standardSellingPrice", data: standardSellingPrice },
    //   { name: "standardTradeRate", data: standardTradeRate },
    //   { name: "standardMrp", data: standardMrp },
    // ];

    // arrayFields.forEach(({ name, data }) => {
    //   data.forEach((item, i) => body.append(`${name}[${i}]`, item));
    // });

    // // Append termConditionForInvoice if it's an object
    // if (termConditionForInvoice && typeof termConditionForInvoice === "object") {
    //   Object.entries(termConditionForInvoice).forEach(([key, value]) => {
    //     body.append(`termConditionForInvoice[${key}]`, value);
    //   });
    // }

    const response = await API.createItem(body);
    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateItem = createAsyncThunk("item/updateItem", async (updatedData, { rejectWithValue, dispatch }) => {
  const { values, id } = updatedData;

  const {
    name,
    aliasName,
    serialNo,
    group,
    baseUnit,
    code,
    harmonicCode,
    category,
    productType,
    description,
    isActive,
    ignoreNegativeBalance,
    canEditRateSales,
    canEditRatePurchase,
    setAlternativeUnit,
    setStandardRate,
    setOpening,
    maintainBatch,
    useMfgDate,
    useExpDate,
    isTaxable,
    allowSalesPoint,
    productAdditionalDetailsProduct,
    productCosting,
    termConditionForInvoice,
    standardCostRate,
    standardSellingPrice,
    standardTradeRate,
    standardMrp,
  } = values;
  try {
    // const body = new FormData();
    const body = JSON.stringify({
      name,
      aliasName,
      serialNo,
      group,
      baseUnit,
      code,
      harmonicCode,
      category,
      productType,
      description,
      isActive,
      ignoreNegativeBalance,
      canEditRateSales,
      canEditRatePurchase,
      setAlternativeUnit,
      setStandardRate,
      setOpening,
      maintainBatch,
      useMfgDate,
      useExpDate,
      isTaxable,
      allowSalesPoint,
      productAdditionalDetailsProduct,
      productCosting,
      termConditionForInvoice,
      standardCostRate,
      standardSellingPrice,
      standardTradeRate,
      standardMrp,
    });

    // // Add common fields
    // const fields = {
    //   name,
    //   aliasName,
    //   serialNo,
    //   group,
    //   baseUnit,
    //   code,
    //   harmonicCode,
    //   category,
    //   productType,
    //   description,
    //   isActive,
    //   ignoreNegativeBalance,
    //   canEditRateSales,
    //   canEditRatePurchase,
    //   setAlternativeUnit,
    //   setStandardRate,
    //   setOpening,
    //   maintainBatch,
    //   useMfgDate,
    //   useExpDate,
    //   isTaxable,
    //   allowSalesPoint,
    // };
    // body.append("name", name);
    // body.append("aliasName", aliasName);
    // body.append("serialNo", serialNo);
    // body.append("group", group);
    // body.append("baseUnit", baseUnit);
    // body.append("code", code);
    // body.append("harmonicCode", harmonicCode);
    // body.append("category", category);
    // body.append("productType", productType);
    // body.append("description", description);
    // body.append("isActive", isActive);
    // body.append("ignoreNegativeBalance", ignoreNegativeBalance);
    // body.append("canEditRateSales", canEditRateSales);
    // body.append("canEditRatePurchase", canEditRatePurchase);
    // body.append("setStandardRate", setStandardRate);
    // body.append("setAlternativeUnit", setAlternativeUnit);
    // body.append("maintainBatch", maintainBatch);
    // body.append("useMfgDate", useMfgDate);
    // body.append("useExpDate", useExpDate);
    // body.append("isTaxable", isTaxable);
    // body.append("allowSalesPoint", allowSalesPoint);

    // const arrayFields = [
    //   { name: "productAdditionalDetailsProduct", data: productAdditionalDetailsProduct },
    //   { name: "productCosting", data: productCosting },
    //   { name: "standardCostRate", data: standardCostRate },
    //   { name: "standardSellingPrice", data: standardSellingPrice },
    //   { name: "standardTradeRate", data: standardTradeRate },
    //   { name: "standardMrp", data: standardMrp },
    // ];

    // arrayFields.forEach(({ name, data }) => {
    //   data.forEach((item, i) => body.append(`${name}[${i}]`, item));
    // });

    // // Append termConditionForInvoice if it's an object
    // if (termConditionForInvoice && typeof termConditionForInvoice === "object") {
    //   Object.entries(termConditionForInvoice).forEach(([key, value]) => {
    //     body.append(`termConditionForInvoice[${key}]`, value);
    //   });
    // }

    const response = await API.updateItem(body, id);
    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("item/handleSearch", async (param, { rejectWithValue }) => {
  const { search, rowsPerPage, sortOrder, pageNo } = param;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
